import { gql } from '@apollo/client';

export const GET_SHOW_GROUPS_ON_DASHBOARD_FOR_CLIENT = gql`
    query GetShowGroupsOnDashboardForClient($id: ID!) {
        client(id: $id) {
            id
            showGroupsOnDashboard
        }
    }
`;
